/**
 * Tab-separated clipboard text — one header line, one line per row — so a copied
 * table pastes straight into Excel / Google Sheets with one value per cell.
 *
 * Two older page-local copies of this escaping exist (`costPriceExport.ts`,
 * `revenueItemsExport.ts`). New callers use this one; folding those two in is a
 * separate cleanup across all three pages.
 */

/** Tabs/newlines inside a cell would break the column alignment when pasted. */
export const escapeTsvCell = (value: string | number): string =>
  String(value ?? '').replace(/[\t\r\n]+/g, ' ');

export function buildTsv(headers: (string | number)[], rows: (string | number)[][]): string {
  const lines = [headers.map(escapeTsvCell).join('\t')];
  for (const row of rows) {
    lines.push(row.map(escapeTsvCell).join('\t'));
  }
  return lines.join('\n');
}
